import type { NotificationConfig } from '../types';

interface NotificationCardProps {
  notification: NotificationConfig;
  onOpenSettings: (notification: NotificationConfig) => void;
}

export default function NotificationCard({ notification, onOpenSettings }: NotificationCardProps) {
  const getChannelIcon = (channel: string) => {
    if (channel === 'sms') return 'ri-message-3-line';
    if (channel === 'email') return 'ri-mail-line';
    if (channel === 'insite') return 'ri-notification-3-line';
    return 'ri-notification-3-line';
  };

  const getChannelName = (channel: string) => {
    if (channel === 'sms') return '短信发送';
    if (channel === 'email') return '邮箱发送';
    if (channel === 'insite') return '站内信发送';
    return '未知渠道';
  };

  const getChannelColor = (channel: string) => {
    if (channel === 'sms') return 'bg-green-50 text-green-600';
    if (channel === 'email') return 'bg-blue-50 text-blue-600';
    if (channel === 'insite') return 'bg-purple-50 text-purple-600';
    return 'bg-gray-50 text-gray-600';
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-900">{notification.name}</h3>
        <span className={`px-2.5 py-1 text-xs rounded-full whitespace-nowrap ${
          notification.enabled
            ? 'bg-green-50 text-green-600'
            : 'bg-gray-100 text-gray-500'
        }`}>
          {notification.enabled ? '已启用' : '已禁用'}
        </span>
      </div>

      <div className="space-y-3 mb-5">
        <div className="flex items-center gap-3 flex-wrap">
          <div className="text-sm text-gray-500">支持发送渠道</div>
          <div className="flex flex-wrap gap-2">
            {notification.channels.map(channel => (
              <div
                key={channel}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm ${getChannelColor(channel)}`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${getChannelIcon(channel)} text-sm`}></i>
                </div>
                <span>{getChannelName(channel)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => onOpenSettings(notification)}
        className="w-full px-4 py-2 bg-teal-500 text-white text-sm rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        设置
      </button>
    </div>
  );
}
